<template>
    <div class="app-container">
        <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="80px">
            <el-form-item label="房号" prop="fangNo">
                <el-input
                    v-model="queryParams.fangNo"
                    placeholder="请输入房号"
                    clearable
                    @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="入住人" prop="userName">
                <el-input
                    v-model="queryParams.userName"
                    placeholder="请输入入住人"
                    clearable
                    @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-select v-model="queryParams.status" placeholder="请选择">
                    <el-option
                        v-for="item in status"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table v-loading="loading" :data="fankuiList" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center" />
            <!--      <el-table-column label="${comment}" align="center" prop="id" />-->
            <el-table-column label="问题内容" align="center" prop="wenTi" />
            <el-table-column label="图片" align="center" prop="img" width="100">
                <template slot-scope="scope">
                    <image-preview :src="scope.row.img" :width="50" :height="50"/>
                </template>
            </el-table-column>
            <el-table-column label="房号" align="center" prop="fangNo" />
            <el-table-column label="入住人" align="center" prop="userName" />
            <el-table-column label="手机号" align="center" prop="phone" />
            <el-table-column label="状态" align="center" prop="status">
                <template slot-scope="scope">
                    <label style="color: #F56C6C" v-if="scope.row.status=='未处理'">未处理</label>
                    <label style="color: #67C23A" v-if="scope.row.status=='已处理'">已处理</label>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="text"
                        @click="handleUpdate(scope.row)"
                        v-if="scope.row.status=='未处理'"
                    >处理完毕</el-button>
                    <!--          <el-button-->
                    <!--            size="mini"-->
                    <!--            type="text"-->
                    <!--            icon="el-icon-delete"-->
                    <!--            @click="handleDelete(scope.row)"-->
                    <!--            v-hasPermi="['fang:fankui:remove']"-->
                    <!--          >删除</el-button>-->
                </template>
            </el-table-column>
        </el-table>

        <pagination
            v-show="total>0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />

        <!-- 添加或修改问题反馈对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="问题内容" prop="wenTi">
                    <el-input v-model="form.wenTi" placeholder="请输入问题内容" />
                </el-form-item>
                <el-form-item label="图片" prop="img">
                    <image-upload v-model="form.img"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { listFankui, getFankui, delFankui, addFankui, updateFankui } from "@/api/homestay/api";

export default {
    name: "Fankui",
    data() {
        return {
            // 根路径
            baseURL: process.env.VUE_APP_BASE_API,
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 问题反馈表格数据
            fankuiList: [],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            status: [{
                value: '未处理',
                label: '未处理'
            }, {
                value: '已处理',
                label: '已处理'
            }],
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                wenTi: null,
                img: null,
                fangNo: null,
                userName: null,
                phone: null,
                status: null,
            },
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                id: [
                    { required: true, message: "$comment不能为空", trigger: "blur" }
                ],
                wenTi: [
                    { required: true, message: "问题内容不能为空", trigger: "blur" }
                ],
                img: [
                    { required: true, message: "图片不能为空", trigger: "blur" }
                ],
                fangNo: [
                    { required: true, message: "房号不能为空", trigger: "blur" }
                ],
                userName: [
                    { required: true, message: "入住人不能为空", trigger: "blur" }
                ],
                phone: [
                    { required: true, message: "手机号不能为空", trigger: "blur" }
                ],
                status: [
                    { required: true, message: "状态 未处理  已处理不能为空", trigger: "blur" }
                ],
                delFlag: [
                    { required: true, message: "删除标志不能为空", trigger: "blur" }
                ],
            }
        };
    },
    created() {
        this.getList();
    },
    methods: {
        /** 查询问题反馈列表 */
        getList() {
            this.loading = true;
            listFankui(this.queryParams).then(response => {
                this.fankuiList = response.data;
                this.total = response.total;
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                id: null,
                wenTi: null,
                img: null,
                fangNo: null,
                userName: null,
                phone: null,
                status: "0",
                delFlag: null,
            };
            this.resetForm("form");
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id)
            this.single = selection.length!==1
            this.multiple = !selection.length
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加问题反馈";
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            const ids = row.id || this.ids.join(',')
            getFankui({'id':ids}).then(() => {
                this.$modal.msgSuccess("已处理");
                this.getList();
                // this.form = response.data;
                // this.open = true;
                // this.title = "修改问题反馈";
            });
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.form.id != null) {
                        updateFankui(this.form).then(() => {
                            this.$modal.msgSuccess("修改成功");
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        addFankui(this.form).then(() => {
                            this.$modal.msgSuccess("新增成功");
                            this.open = false;
                            this.getList();
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const idss = row.id || this.ids.join(',');
            this.$modal.confirm('是否确认删除问题反馈编号为"' + idss + '"的数据项？').then(function() {
                return delFankui({'ids': idss});
            }).then(() => {
                this.getList();
                this.$modal.msgSuccess("删除成功");
            }).catch(() => {});
        },
        /** 导出按钮操作 */
        handleExport() {
            // this.download('fang/fankui/export', {
            //     ...this.queryParams
            // }, `fankui_${new Date().getTime()}.xlsx`)
        }
    }
};
</script>
